<template functional>
  <div
    :class="[ data.staticClass, data.class ]"
    class="c-player-controls__bar--embedded"
  >
    <div class="c-player__btn--fill">
      <ui-player-live-time-shift v-if="parent.isLive"></ui-player-live-time-shift>
      <ui-player-progress-bar v-else></ui-player-progress-bar>
    </div>
    <div class="c-player__control-buttons c-player__control-buttons--embedded">
      <div class="u-flex u-flex-row u-flex-align-center">
        <div class="c-player__btn">
          <ui-player-toggle-play></ui-player-toggle-play>
        </div>
        <div class="c-progress-bar__time">
          {{ parent.timeElapsed }} / {{ parent.duration }}
        </div>
      </div>
      <div class="u-flex u-flex-row u-flex-align-center">
        <div class="c-player__btn">
          <ui-player-previous-element></ui-player-previous-element>
        </div>
        <div class="c-player__btn u-desktop-only">
          <i
            v-if="parent.isTimeshiftEnabled"
            v-accessibility-focus="parent.seekBackward"
            class="o-icon o-icon--minus-10"
            :aria-label="parent.$t('player.seekBackward')"
          ></i>
        </div>
        <div class="c-player__btn u-desktop-only">
          <i
            v-if="parent.isTimeshiftEnabled"
            v-accessibility-focus="parent.seekForward"
            class="o-icon o-icon--plus-10"
            :aria-label="parent.$t('player.seekForward')"
          ></i>
        </div>
        <div
          v-if="parent.isLive"
          class="c-player__btn"
        >
          <ui-player-live-button></ui-player-live-button>
        </div>
        <div class="c-player__btn">
          <ui-player-volume></ui-player-volume>
        </div>
        <div class="c-player__btn">
          <ui-player-next-element></ui-player-next-element>
        </div>
        <div
          v-if="!parent.isEmbedded"
          class="c-player__btn"
        >
          <i
            class="o-icon o-icon--episodes"
            @click="parent.toggleSeasons"
          ></i>
        </div>
        <div
          v-if="parent.optionsAvailable"
          class="c-player__btn"
        >
          <i
            v-accessibility-focus="parent.toggleOptions"
            :aria-label="parent.$t('accessibility.player.options')"
            class="o-icon o-icon--settings"
          ></i>
        </div>
        <div class="c-player__btn">
          <ui-player-fullscreen-btn></ui-player-fullscreen-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'UiEmbeddedPlayer',
  };
</script>
